export interface paymentBillParamsType {
  roomIdList?: string[];
  chargeStateList?: number[];
  state: number;
  ownerId: string;
}

export interface paymentBillType {
  
  additionalAmount?: number | null;
  amount?: number;
  amountDefault?: number;
  amountPreferential?: number;
  answerTime?: string;
  category?: number;
  chargeState?: number;
  communityId?: string;
  communityName?: string;
  consumption?: number;
  creatorTime?: string;
  creatorUserId?: string | null;
  deleteTime?: string | null;
  deleteUserId?: string | null;
  description?: string | null;
  feeConfigId?: string;
  feeEndDay?: string;
  feeName?: string;
  feeStartDay?: string;
  feeType?: string;
  generationMethod?: number;
  id?: string;
  interimFlag?: number;
  invoiceState?: string | null;
  meterStatusVOList?: any[] | null; // 根据实际情况定义具体类型
  orgId?: string;
  orgName?: string;
  ownerId?: string;
  ownerName?: string;
  ownerNum?: string;
  paidAmount?: number;
  payFeeType?: string | null;
  paymentBillId?: string | null;
  phoneNumber?: string;
  refundsReason?: string | null;
  roomBuiltUpArea?: number;
  roomId?: string;
  roomNum?: string;
  roomState?: string;
  roomType?: string;
  squarePrice?: number;
  state?: number;
  surplus?: number;
  totalAmount?: number;
  waterCardNumber?: string;
  waterLastCardInsertion?: string;
  yearsMonth?: string;
  checked?: boolean;
  expand?: boolean;
}

export interface FeeDetailsType<T> {
  yearsMonth: string;
  expand: boolean;
  checked: boolean;
  feeTypeList: T;
  amount: string;
  amountDefault?: string;
}

export interface PaymentBillRequestType {
  METER: PaymentBillListType[];
  GENERAL: PaymentBillListType[];
}

export interface PaymentBillListType {
  feeItemId: string; // 费用项ID
  priceOrAmount: string; // 单价或金额
  usageOrAcreage: string; // 使用量或面积
  itemCategoryName: string; // 费用类别名称
  discountAmount: string; // 优惠金额
  isTemporary: string; // 是否临时费用
  itemCategoryId: string; // 费用类别ID
  payableAmount: string; // 应付金额
  totalAmount: string; // 总金额
  billMonths: string; // 账单月份范围
  bills: BillItemType[]; // 账单详情列表
  feeItemName: string; // 费用项名称
  penaltyAmount: string; // 滞纳金金额
  checked: boolean;
  expand: boolean;
}

export const billTypeMap: Record<string, string> = {
  GENERAL: '常规',
  METER: '仪表',
};

export interface BillItemType {
  unitPriceFormat?: string;
  sequenceNbr: string; // 序列号
  createBy: string; // 创建人
  createTime: string; // 创建时间
  paymentNo: string | null; // 支付编号
  billNo: string; // 账单编号
  billType: string; // 账单类型
  billMonth: string; // 账单月份
  feeItemId: string; // 费用项ID
  feeItemName: string; // 费用项名称
  priceOrAmount: string; // 单价或金额
  usageOrAcreage: string; // 使用量或面积
  totalAmount: string; // 总金额
  payableAmount: string; // 应付金额
  discountAmount: string; // 优惠金额
  penaltyAmount: string; // 滞纳金金额
  balanceDeduction: string; // 余额抵扣
  actualAmount: string; // 实际金额
  isTemporary: boolean; // 是否临时费用
  refund: boolean; // 是否退款
  refundAmount: string; // 退款金额
  roomId: string; // 房间ID
  roomCode: string; // 房间编码
  customerId: string; // 客户ID
  unitId: string; // 单元ID
  floorId: string; // 楼层ID
  communityId: string; // 社区ID
  regionId: string; // 区域ID
  checkoutStatus: string; // 结算状态
  auditStatus: string; // 审核状态
  checkoutUserId: string; // 结算用户ID
  checkoutTime: string | null; // 结算时间
  billStartDate: string; // 账单开始日期
  billEndDate: string; // 账单结束日期
  meterType: string; // 表计类型
  meterStatus: string; // 表计状态
  meterId: string; // 表计ID
  cardNo: string; // 卡号
  swipingCardTime: string; // 刷卡时间
  surplus: string; // 余额
  priorPeriodReading: string; // 上期读数
  currentPeriodReading: string; // 本期读数
  additional: string; // 附加费用
  discountMethod: string; // 优惠方式
  discountPercent: string; // 优惠百分比
  itemParameterValue: string; // 项目参数值
  itemCategoryId: string; // 项目类别ID
  itemCategoryName: string; // 项目类别名称
  roomName: string; // 房间名称
  buildArea: string; // 建筑面积
  customerName: string; // 客户名称
  phone: string | null; // 电话号码
  feeBindId: string; // 费用绑定ID
  lastAuditUser: string | null; // 最后审核人
  lastAuditUserId: string | null; // 最后审核用户ID
  lastAuditTime: string | null; // 最后审核时间
  creationMethod: string; // 创建方式
  coefficient: string; // 系数
  additionalFee: string; // 附加费用
  amountCalRule: string; // 金额计算规则
  priorPeriodTime: string | null; // 上期时间
  currentPeriodTime: string | null; // 本期时间
  billValid: string; // 账单有效性
  checkoutUser: string | null; // 结算用户
  companyId: string; // 公司ID
  images: string | null; // 图片
  attachment: string | null; // 附件
  discountRemark: string | null; // 优惠备注
  dynamicFeeInstance: DynamicFeeInstanceType[]; // 动态费用实例
  payChannel: string | null; // 支付渠道
  roomIds: string | null; // 房间IDs
  billNos: string | null; // 账单编号列表
  preUsage: string | null; // 预使用量
  billMonthList: string | null; // 账单月份列表
  currentReading: string | null; // 当前读数
  currentUsage: string | null; // 当前使用量
  recordMonth: string | null; // 记录月份
  meterNo: string | null; // 表计编号
  surplusMethod: string | null; // 余额方法
  surplusBeforeAmount: string | null; // 余额前金额
  surplusAfterAmount: string | null; // 余额后金额
  checked: boolean;
  expand: boolean;
}

export interface DynamicFeeInstanceType {
  sequenceNbr: string; // 序列号
  createBy: string; // 创建人
  createTime: string; // 创建时间
  itemDynamicId: string; // 项目动态ID
  orderNo: string; // 订单号
  itemId: string; // 项目ID
  lower: string; // 下限
  upper: string; // 上限
  price: string; // 价格
  amount: string; // 金额
  optionName: string; // 选项名称
  serialNumber: number; // 序列号
  usageOrAcreage: string; // 使用量或面积
}

export interface ComputedBillTotalAmountParamsType {
  billDiscountAmount: number; // 账单优惠总计
  billDiscountList: Array<{
    billNo: string; // 账单编号
    discountAmount: number; // 账单优惠金额
    discountMethod: 'MONEY' | 'PERCENT' | 'NOCOUPON'; // 账单优惠方式：按金额 MONEY，按比例 PERCENT，无优惠 NOCOUPON
    discountPercent: number; // 账单优惠百分比
  }>; // 账单分项优惠信息列表
  billNos: string[]; // 要缴费的账单编号
  cardBillNo: string | null; // 卡表账单编号
  customerId: string; // 客户ID
  discountMethod: 'MONEY' | 'PERCENT' | 'NOCOUPON'; // 整单优惠方式：按金额 MONEY，按比例 PERCENT，无优惠 NOCOUPON
  discountPercent: number; // 整单优惠百分比
  discountStrategy: 'PAYMENT_DISCOUNT' | 'BILL_DISCOUNT' | 'NOCOUPON'; // 优惠策略：整单优惠：PAYMENT_DISCOUNT，分项优惠 BILL_DISCOUNT，无优惠 NOCOUPON
  isDeduction: boolean; // 是否余额抵扣
  paymentAmount: number; // 实缴金额
  paymentDiscountAmount: number; // 整单优惠金额
  surplusMethod: 'RECHARGE' | 'RETURN'; // 结转方式：结转 RECHARGE，找零 RETURN
}
